import { defineComponent as _defineComponent } from 'vue'
import { ref } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { TUIConstants } from '@tencentcloud/tui-core';
import { isPC } from '../../../utils/env';
import TUIChatConfig from '../config';


export default /*#__PURE__*/_defineComponent({
  __name: 'message-input-button',
  props: {
  enableSend: {
    type: Boolean,
    default: true,
  },
},
  emits: ['sendMessage'],
  setup(__props, { emit: emits }) {

const props = __props



const displayHover = ref(TUIChatConfig.getChatType() !== TUIConstants.TUIChat.TYPE.ROOM);



const sendMessage = () => {
  emits('sendMessage');
};

return { __sfc: true,props, displayHover, emits, sendMessage, TUITranslateService, isPC }
}

})